import { render } from "./FooterSeven.vue?vue&type=template&id=210d12bf&scoped=true"
import script from "./FooterSeven.vue?vue&type=script&lang=js"
export * from "./FooterSeven.vue?vue&type=script&lang=js"

import "./FooterSeven.vue?vue&type=style&index=0&id=210d12bf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210d12bf"]])

export default __exports__